import { Injectable } from '@angular/core';
import { UserManager, User,WebStorageStateStore } from 'oidc-client';
import { Subject } from 'rxjs';
import { EnvService } from './env.service';
import { AppService} from '../commonservices/app.service';
import { CookieStorage } from 'cookie-storage';

@Injectable()
export class AuthService {
  private _userManager: UserManager;
  private _user: User;
  private _loginChangedSubject = new Subject<boolean>();
  loginChanged = this._loginChangedSubject.asObservable();
  public redirectUrl: string;
  env: EnvService;

  constructor(public _env: EnvService,
              public _appService: AppService) {
                this.env = _env;
                //authorization with pkce
                const stsSettings = {
                  authority: this.env .stsAuthority,
                  client_id: this.env .clientId,
                  redirect_uri: `${this.env .clientRoot}signin-callback`,
                  scope: 'openid profile ctwebapi ratetrakapi webresolutionapi ctglobalapi rateengineapi ruleapi webstoreapi edataapi tmsapi raterequestapi',
                  response_type: 'id_token token',
                  post_logout_redirect_uri: `${this.env .clientRoot}signout-callback`,
                  accessTokenExpiringNotificationTime: 1800, //if identity accesstoken life is 1 hr  then 1hr - 1800 this will triger the silent call back.
                  automaticSilentRenew: true,
                  silent_redirect_uri: `${this.env .clientRoot}assets/silent-callback.html`,
                  loadUserInfo: true,
                  userStore: new WebStorageStateStore({ store: new CookieStorage() }),
                };
                this._userManager = new UserManager(stsSettings);
  }

  login(returnUrl) {
    return this._userManager.signinRedirect({state:returnUrl});
  }

  isLoggedIn(): Promise<boolean> {
    return this._userManager.getUser().then(user => {
      const userCurrent = !!user && !user.expired;

      if (this._user !== user) {
        this._loginChangedSubject.next(userCurrent);
      }
      
      this._user = user;
      return userCurrent;
    });
  }
  
  completeLogin() {
    return this._userManager.getUser().then(user => {
      if(user == null)
      {
        return this._userManager.signinRedirectCallback().then(user => {
          this._user = user;
          this._loginChangedSubject.next(!!user && !user.expired);
          return user;
        });
      }else
      {
        this.completeLogout();
      }
    });
  }
  
  logout() {
    this._userManager.signoutRedirect();
  }

  completeLogout() {
    this._user = null;
    this._loginChangedSubject.next(false);
    return this._userManager.signoutRedirectCallback();
  }

  getAccessToken() {
    return this._userManager.getUser().then(user => {
      if (!!user && !user.expired) {
        return user.access_token;
      }
      else {
        return null;
      }
    });
  }
  //get details sent by identity server
  getUserIdentity() {
    return this._userManager.getUser().then(user => {
      if (!!user) {
        return user;
      }
      else {
        return null;
      }
    });
  }
}